import React from 'react';
import './PermissionEditor.css';

export function expandPermissions(values, dependencies = {}) {
  const result = new Set(values);
  let previousSize;
  do {
    previousSize = result.size;
    [...result].forEach(value => (dependencies[value] || []).forEach(item => result.add(item)));
  } while (previousSize !== result.size);
  return [...result];
}

// Removing a prerequisite also removes the permissions that require it.
export function changePermissions(values, added, removed, dependencies = {}) {
  const excluded = new Set(removed);
  let previousSize;
  do {
    previousSize = excluded.size;
    values.forEach(value => {
      if ((dependencies[value] || []).some(item => excluded.has(item))) excluded.add(value);
    });
  } while (previousSize !== excluded.size);
  return expandPermissions([...values.filter(value => !excluded.has(value)), ...added], dependencies);
}

export function permissionSummary(values = [], modules = []) {
  return modules.flatMap(module => [
    values.includes(module.write) ? `${module.label}：维护`
      : values.includes(module.read) ? `${module.label}：查看` : null,
    ...(module.extras || []).filter(item => values.includes(item.permission)).map(item => item.label)
  ]).filter(Boolean).join(' · ') || '无权限';
}

export default function PermissionEditor({ value = [], catalog, onChange, idPrefix }) {
  const { modules = [], dependencies = {} } = catalog;
  return <div className="permission-editor">
    <p className="configuration-dialog-description">选择维护权限会自动补齐查看及关联模块权限；降低权限会同时移除依赖它的权限。规则维护者可使用已启用的 AI 渠道。</p>
    <div className="permission-module-grid">
      {modules.map(module => {
        const level = value.includes(module.write) ? 'write' : value.includes(module.read) ? 'read' : 'none';
        return <div className="permission-module" key={module.id}>
          <div className="permission-module-heading">
            <label className="form-label" htmlFor={`${idPrefix}-${module.id}`}>{module.label}</label>
            <select id={`${idPrefix}-${module.id}`} className="form-select" value={level} onChange={event => {
              const next = event.target.value;
              const removed = next === 'none' ? [module.read, module.write].filter(Boolean)
                : next === 'read' ? [module.write].filter(Boolean) : [];
              const added = next === 'none' ? [] : [module[next]];
              onChange(changePermissions(value, added, removed, dependencies));
            }}>
              <option value="none">无权限</option><option value="read">查看</option>
              {module.write && <option value="write">维护</option>}
            </select>
          </div>
          {module.description && <p className="permission-module-description">{module.description}</p>}
          {(module.extras || []).map(item => <label className="permission-extra" key={item.permission}>
            <input type="checkbox" checked={value.includes(item.permission)} onChange={event => onChange(changePermissions(
              value, event.target.checked ? [item.permission] : [], event.target.checked ? [] : [item.permission], dependencies
            ))} />{item.label}
          </label>)}
        </div>;
      })}
    </div>
  </div>;
}
